<template>
  <EasyDataTable
    :headers="participantsFields"
    :items="participants"
    :alternating="true"
    :rows-per-page="10000"
    :hide-rows-per-page="true"
  >
  </EasyDataTable>
</template>

<script>
export default {
  name: 'participants-table',
  props: {
    participants: [],
    selectedTestType: ''
  },
  computed: {
    participantsFields() {
      var fields = []

      if (
        this.selectedTestType === 'PIN' ||
        this.selectedTestType === 'ANONYMOUS'
      ) {
        fields.push({
          value: 'pin',
          text: this.$t('privatePage.pin'),
          sortable: false
        })
      }

      if (this.selectedTestType === 'EMAIL') {
        fields.push({
          value: 'email',
          text: this.$t('privatePage.email'),
          sortable: false
        })
      }

      fields.push({
        value: 'firstname',
        text:
          this.selectedTestType === 'ANONYMOUS'
            ? this.$t('privatePage.testsuite_alias')
            : this.$t('privatePage.first_name'),
        sortable: false
      })

      if (
        this.selectedTestType === 'PIN' ||
        this.selectedTestType === 'EMAIL'
      ) {
        fields.push({
          value: 'lastname',
          text: this.$t('privatePage.last_name'),
          sortable: false
        })
      }

      return fields
    }
  }
}
</script>
